import error from '@/assets/images/analysis-error.webp';
import success from '@/assets/images/success-icon.webp';
import type { FC, ReactNode } from 'react';

export const Result: FC<
  { title: string; desc: string; children: ReactNode } & Partial<{
    type: 'success' | 'error';
  }>
> = (props) => {
  // props
  const { title, desc, type, children } = props;

  return (
    <section className="flex flex-col justify-center items-center w-full h-full -mt-6">
      <img
        className="mb-3"
        src={type === 'error' ? error : success}
        width={70}
        alt="result icon"
      />
      <p className="mb-2 text-base font-medium text-main">{title}</p>
      <p className="mb-5 text-sm text-secondary-2">{desc}</p>
      <div>{children}</div>
    </section>
  );
};
